import { FC } from 'react'
import { withHeaderHOC } from 'shared/HOCs/withHeaderHOC'
import { withSideBarHOC } from 'shared/HOCs/withSidebarHOCs'
import { NotificationsAccordion } from 'widgets/_Accordions/Notifications'

export const NotificationsComponent: FC = () => {
  return (
    <>
      <NotificationsAccordion />
    </>
  )
}

// TODO: translations
export const Notifications = withSideBarHOC(withHeaderHOC(NotificationsComponent, 'Notifications'))
